var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_flex _flexcol _pa-2 _pa-5--m",
      attrs: { "data-qa": `backer-center-payments-list-item:${_vm.paymentID}` },
    },
    [
      _c("backer-center-header", {
        scopedSlots: _vm._u([
          {
            key: "prefix",
            fn: function () {
              return [
                _c("backer-center-thumbnail", {
                  attrs: {
                    url: _vm.yourPledgeUrl,
                    "image-url": _vm.projectImageUrl,
                    name: _vm.name,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "base-text",
                  {
                    staticClass: "_toe",
                    attrs: {
                      as: "a",
                      level: "b1",
                      href: _vm.formattedYourPledgeUrl,
                      title: _vm.name,
                      "data-qa":
                        "backer-center-payments-list-item-data:ProjectUrl",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s(_vm.name) + "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gfu-bt--caption _tc--light" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formattedDate) +
                        "\n                "
                    ),
                    _vm.hasInstallments
                      ? [
                          _c("span", [_vm._v("•")]),
                          _vm._v(" "),
                          _c(
                            "localize",
                            {
                              attrs: {
                                resource:
                                  _vm.Resources.BackerCenter
                                    .XOfYInstallmentLabel,
                              },
                            },
                            [
                              _c("span", { attrs: { "format-key": "0" } }, [
                                _vm._v(_vm._s(_vm.installmentSequenceNumber)),
                              ]),
                              _vm._v(" "),
                              _c("span", { attrs: { "format-key": "1" } }, [
                                _vm._v(_vm._s(_vm.numberOfInstallmentsInPlan)),
                              ]),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "suffix",
            fn: function () {
              return [
                _c(
                  "span",
                  {
                    class: _vm.amountClasses,
                    attrs: {
                      "data-qa": "backer-center-payments-list-item-data:Amount",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formattedAmount) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.hasActions
                  ? _c("balloon-actions", {
                      attrs: {
                        actions: _vm.balloonActions,
                        theme: "lightOutline",
                        mode: _vm.balloonActionsModes.grouped,
                        "balloon-style-props": _vm.balloonStyleProps,
                        "data-qa": "payments-card:Actions",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }